import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { startLoadingActionsByProject } from '../../actions/action';
import { actionStateSelector } from '../../selectors/action';
import ActionItem from '../action-item';
import LoadingSpinner from '../loading-spinner';
import ErrorPageContainer from '../page-error';
import { MyActionsContent, MyActionsStyled, MyActionsTitle } from './styled';
const MyActions = () => {
  const dispatch = useDispatch();
  const {
    actions,
    actionsError,
    actionsLoading
  } = useSelector(actionStateSelector);
  React.useEffect(() => {
    dispatch(startLoadingActionsByProject());
  }, []);
  return /*#__PURE__*/React.createElement(MyActionsStyled, null, /*#__PURE__*/React.createElement(MyActionsTitle, null, "Actions"), /*#__PURE__*/React.createElement(MyActionsContent, null, actionsLoading ? /*#__PURE__*/React.createElement(LoadingSpinner, null) : actionsError ? /*#__PURE__*/React.createElement(ErrorPageContainer, {
    error: {
      message: actionsError.message || actionsError
    }
  }) : actions?.length ? actions.sort((a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt)).map(action => /*#__PURE__*/React.createElement(ActionItem, {
    key: action.id,
    action: action
  })) : null));
};
export default MyActions;